var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 29,
    viewBox: "0 0 25 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.15 15.256c-.012-2.365 1.051-4.15 3.202-5.466-1.203-1.733-3.022-2.687-5.423-2.874-2.273-.18-4.758 1.334-5.667 1.334-.96 0-3.163-1.27-4.892-1.27C3.797 7.038 0 9.848 0 15.565 0 17.255.307 19 .922 20.8c.82 2.366 3.778 8.166 6.864 8.07 1.614-.04 2.754-1.154 4.854-1.154 2.036 0 3.093 1.154 4.892 1.154 3.112-.046 5.788-5.318 6.57-7.69-4.175-1.978-3.951-5.8-3.951-5.923zM16.528 4.673C18.275 2.585 18.115.683 18.063 0c-1.543.09-3.33 1.057-4.347 2.25-1.12 1.276-1.78 2.855-1.64 4.634 1.672.128 3.196-.735 4.45-2.211z",
    fill: "#1A1824"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/Apple.fa40d30a8a193d22421743a46c28b31b.svg";
export { ForwardRef as ReactComponent };